import { render, staticRenderFns } from "./MessageSearch.vue?vue&type=template&id=1be9f04c"
import script from "./MessageSearch.vue?vue&type=script&lang=js"
export * from "./MessageSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports